import React from 'react';

const ReportContent = ({ data }) => {
    return (
        <>

            <table id="material-storage-data" className="table report-table">
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className={'w-[15%]'}>Depósito</th>
                        <th className={'w-[15%]'}>Grupo</th>
                        <th className={'w-[29%]'}>Material</th>
                        <th className={'w-[10%]'}>Total</th>
                        <th className={'w-[10%]'}>Em cautela</th>
                        <th className={'w-[10%]'}>Disponível</th>
                        <th className={'w-[10%]'}>Indisponível</th>
                    </tr>
                </thead>
                <tbody className="bg-white">
                    { data.map((element, index) => {
                        return (
                            <tr key={index} className="table-break-word">
                                <td className={'w-[15%]'}>{element.storage ?? ""}</td>
                                <td className={'w-[15%]'}>{element.group ?? ""}</td>
                                <td className={'w-[29%]'}>{element.material ?? ""}</td>
                                <td className={'w-[10%]'}>{element.quantity ?? "0"}</td>
                                <td className={'w-[10%]'}>{element.caution ?? "0"}</td>
                                <td className={'w-[10%]'}>{element.available ?? "0"}</td>
                                <td className={'w-[10%]'}>{element.unavailable ?? "0"}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

        </>
    );
};

export default ReportContent;